module.exports = __webpack_public_path__ + "static/media/Graphic-serviceIcon.2a224551.png";